<mat-form-field appearance="outline">
  <input matInput type="text" [formControl]="myControl" [matAutocomplete]="autoProduct" [readonly]="readOnly"
    (input)="onInput()" class="product-search" placeholder="Concepto del gasto">
  <mat-autocomplete #autoProduct="matAutocomplete" (optionSelected)="expenseSelected($event.option.value)">
    <ng-container *ngFor="let expense of $expenses | async">
      <mat-option [value]="expense">
        {{expense?.name}} {{expense?.amount | money : { needSymbol:true } }}
      </mat-option>
    </ng-container>
    <mat-option [value]="null" class="always-visible-option">
      <button type="button" class="btn btn-link text-manax mx-1 p-1" (click)="openNewExpenseModal()"
        style="text-transform: capitalize;">
        Agregar Gasto <i class="material-icons">add</i>
      </button>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>